import React from 'react';
import './Loading.css';

const Loading = () => {
  return (
    <div className="loading-overlay">
      <div className="loading-container">
        <div className="loading-spinner">
          <div className="spinner-ring"></div>
          <div className="spinner-ring"></div>
          <div className="spinner-ring"></div>
        </div>
        <div className="loading-text">
          <span className="loading-brand">Randevu345</span>
          <span className="loading-message">Yükleniyor...</span>
        </div>
      </div>
    </div>
  );
};

export default Loading; 